export const  ApplyOdCoColumns = [
    "EmployeeCode",
    // "EmployeeName",
    "Type",
    "FromDate",
    "ToDate",
    "NoOfDays",
    "Reason",
    // "LeaveAddress"  
];
